import { Home, TrendingUp, Activity, User } from 'lucide-react';
import { Skeleton, SkeletonCircle } from './SkeletonBase';

export default function ProgressSkeleton() {
  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      <div className="max-w-2xl mx-auto">
        <header className="bg-white px-6 py-4 flex items-center justify-between sticky top-0 z-10 border-b border-gray-200">
          <div className="flex items-center gap-3">
            <Skeleton className="w-10 h-10 rounded-xl" />
            <div>
              <Skeleton className="h-5 w-32 mb-1" />
              <Skeleton className="h-3 w-24" />
            </div>
          </div>
          <Skeleton className="w-10 h-10 rounded-lg" />
        </header>

        <div className="p-4 space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-white rounded-2xl p-5 border border-gray-200">
              <div className="flex items-center justify-between mb-3">
                <Skeleton className="w-5 h-5 rounded" />
                <Skeleton className="w-12 h-6 rounded-full" />
              </div>
              <Skeleton className="h-3 w-16 mb-2" />
              <Skeleton className="h-9 w-12" />
            </div>

            <div className="bg-white rounded-2xl p-5 border border-gray-200">
              <div className="flex items-center justify-between mb-3">
                <Skeleton className="w-5 h-5 rounded" />
                <Skeleton className="w-12 h-6 rounded-full" />
              </div>
              <Skeleton className="h-3 w-16 mb-2" />
              <Skeleton className="h-9 w-12" />
            </div>
          </div>

          <div className="bg-white rounded-2xl p-5 border border-gray-200">
            <Skeleton className="h-3 w-24 mb-4" />
            <div className="grid grid-cols-2 gap-3">
              <Skeleton className="h-28 rounded-xl" />
              <Skeleton className="h-28 rounded-xl" />
            </div>
          </div>

          <div className="bg-white rounded-2xl border border-gray-200">
            <Skeleton className="h-3 w-24 mx-5 mt-5 mb-3" />
            <div className="grid grid-cols-4 gap-2 px-5 pb-5">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="flex flex-col items-center gap-2 p-3">
                  <Skeleton className="w-12 h-12 rounded-xl" />
                  <Skeleton className="h-2 w-8" />
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white rounded-2xl p-5 border border-gray-200">
            <div className="flex items-center justify-between mb-4">
              <div>
                <Skeleton className="h-3 w-24 mb-2" />
                <Skeleton className="h-4 w-20" />
              </div>
              <Skeleton className="w-16 h-7 rounded-full" />
            </div>
            <Skeleton className="h-48 w-full rounded-xl mb-4" />
            <Skeleton className="h-16 w-full rounded-xl" />
          </div>

          <Skeleton className="h-40 w-full rounded-2xl" />
        </div>

        <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-30 safe-area-inset-bottom">
          <div className="max-w-2xl mx-auto px-4 py-3 flex items-center justify-around">
            <button className="flex flex-col items-center gap-1 text-gray-400 min-w-[60px]">
              <Home size={22} strokeWidth={2} />
              <span className="text-[10px] font-bold">Home</span>
            </button>
            <button className="flex flex-col items-center gap-1 text-cyan-600 min-w-[60px] relative">
              <div className="absolute -top-1 w-12 h-0.5 bg-cyan-600 rounded-full"></div>
              <TrendingUp size={22} strokeWidth={2.5} />
              <span className="text-[10px] font-bold">Progress</span>
            </button>
            <button className="flex flex-col items-center gap-1 text-gray-400 min-w-[60px]">
              <Activity size={22} strokeWidth={2} />
              <span className="text-[10px] font-bold">Activity</span>
            </button>
            <button className="flex flex-col items-center gap-1 text-gray-400 min-w-[60px]">
              <User size={22} strokeWidth={2} />
              <span className="text-[10px] font-bold">Profile</span>
            </button>
          </div>
        </nav>
      </div>
    </div>
  );
}
